import { connect } from 'react-redux';
import OBS from './OBS';

import {
    setOBSTerm,
    setOBSCredit,
    setShowOBS,
    setOBSDownPayment,
} from '../../common/obs/actions';

import { setOBSIsVisible } from './actions';

import { setSelectedFinancing } from '../../common/settings/actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    isVisible: state.obsUI.isVisible,
    obsDownPayment: state.obs.obsDownPayment,
    cashprice: state.solar.cashprice,
    obsTerm: state.obs.obsTerm,
    obsCredit: state.obs.obsCredit,
    showOBS: state.obs.showOBS,
    resiToggle: state.tax.resiToggle,
    setOBSIsVisible,
    setOBSTerm,
    setOBSCredit,
    setOBSDownPayment,
    setShowOBS,
    setSelectedFinancing,
});

const combinedActions = {
    setOBSIsVisible,
    setOBSDownPayment,
    setOBSTerm,
    setOBSCredit,
    setShowOBS,
    setSelectedFinancing,
};

export default connect(mapStateToProps, combinedActions)(OBS);



// WEBPACK FOOTER //
// ./src/containers/Inputs/OBS/index.js